
import { useEffect, useState } from 'react'
import axios from 'axios';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import { createContact, logOutApi, detailGroup, updateContact, listContact } from '../../../Context/api';
import { groupAddValidation } from '../../../Context/validation';
import { commonMessage, statusCodes } from '../../../Constants/generalConfig';
import { useNavigate, useParams } from 'react-router-dom';
const UseAddGroup = () => {
    const [spinner, setSpinner] = useState(false)
    const [contactsList, setContactsList] = useState([])
    const adminData = JSON.parse(localStorage.getItem('adminData'));
    const navigate = useNavigate()
    const { id } = useParams()
    useEffect(() => {
        if (id) {
            getGroup()
        }
    }, [])

    useEffect(() => {
        contact_list()
    }, [])

    const contact_list = () => {
        setSpinner(true)
        axios.post(listContact(), { type: "ADMIN", count: 100, page: 1, }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                setContactsList(resp.data?.data)
                setSpinner(false)
            }
            else {
                setContactsList([])
                setSpinner(false)
            }
        })
            .catch(() => {
                toast.error(commonMessage.networkError)
                setSpinner(false)
            })
    }

    const logOutFun = () => {
        axios.post(logOutApi(), { deviceId: adminData.deviceId, userId: adminData.userId, type: 'WEBADMIN' }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                localStorage.removeItem('adminData')
                navigate('/')
            }
        })
    }
    const getGroup = () => {
        axios.post(detailGroup(), { id: id }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                addGroup.setFieldValue('contact', resp?.data?.data?.contactData?.map((item) => item?._id))
                addGroup.setFieldValue('name', resp?.data?.data?.name)
                addGroup.setFieldValue('description', resp?.data?.data?.description)
            }
            else if (resp.data.code === statusCodes.tokenExpire) {
                logOutFun()
            }
            else {
                toast.error(resp.data.message)
                setSpinner(false)
            }
        })
            .catch(() => {
                toast.error(commonMessage.networkError)
            })
    }
    const addGroup = useFormik({
        initialValues: {
            name: '',
            description: '',
            contact: []
        },
        validationSchema: groupAddValidation,
        onSubmit: (values) => {
            const data = {
                name: values.name.trim(),
                contactIds: values?.contact,
                type: 'ADMIN',
                description: values.description,
                isGroup: true
            }
            if (id) {
                data.id = id
            }
            // console.log(data, 'PPPPPPPPPPPPPPPPPP')
            // return
            setSpinner(true)
            axios.post(id ? updateContact() : createContact(), { ...data }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
                if (resp.data.code === statusCodes.ok) {
                    toast.success(resp.data.message)
                    setSpinner(false)
                    setTimeout(() => {
                        navigate(-1)
                        addGroup.resetForm()
                    }, 1000);
                }
                else if (resp.data.code === statusCodes.tokenExpire) {
                    logOutFun()
                }
                else {
                    toast.error(resp.data.message)
                    setSpinner(false)
                }
            })
                .catch(() => {
                    toast.error(commonMessage.networkError)
                })

        }

    })

    const selectAllOption = { _id: "select-all", name: "Select All" };
    const optionsWithSelectAll = [selectAllOption, ...contactsList];

    const handleContactChange = (event, newValue) => {
        if (newValue.some(option => option._id === "select-all")) {
            if (newValue.length === contactsList.length + 1) {
                addGroup.setFieldValue('contact', [])
            } else {
                addGroup.setFieldValue('contact', contactsList.map(item => item._id))
            }
        } else {
            addGroup.setFieldValue('contact', newValue.map(cur => cur._id))
        }
    };
    return {
        navigate,
        contact_list,
        handleContactChange,
        id,
        spinner,
        contactsList,
        addGroup,
        optionsWithSelectAll,
        

    }
}

export default UseAddGroup